import { render, staticRenderFns } from "./RelatedCategoryMedia.vue?vue&type=template&id=8905ddae&"
import script from "./RelatedCategoryMedia.vue?vue&type=script&lang=js&"
export * from "./RelatedCategoryMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports